import React, { useContext, useEffect } from 'react'
import { Modal, notification } from 'antd'
import { useTranslation } from 'react-i18next'
import { post } from '../../Common/api'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import PublicContext from '../PublicContext'
import MobileAppointmentPage from './Mobile/MobileAppointmentPage'
import ComputerAppointmentPage from './Computer/ComputerAppointmentPage'
import TabletAppointmentPage from './Tablet/TabletAppointmentPage'
import { screenSize } from '../../Common/Common'
const { confirm } = Modal

export default function AppointmentPage () {
  const { appointment, setSiderTitle, appointmentStatus, setAppointment, updateStatus, setSiderDisabled } = useContext(PublicContext)
  const { t } = useTranslation()

  const onCancel = () => {
    confirm({
      icon: <ExclamationCircleOutlined />,
      content: t('Public.ConfirmedAppointment.modalConfirm'),
      onOk () {
        post({
          url: `public/appointments/${appointment.id}/cancel`,
          params: {},
          onSuccess: (json) => {
            setAppointment(json)
            updateStatus(json)
          },
          onFailure: (json) => {
            setAppointment(json)
            updateStatus(json)
            notification.error({ message: 'Annulation impossible: le rendez-vous est en cours ou terminé', placement: 'bottom' })
          }
        })
      }
    })
  }

  const titles = {
    timeout: 'TimeoutAppointmentPage',
    cancel: 'CancelAppointmentPage',
    clean_in_progress: 'ConfirmedAppointmentPage',
    done: 'ConfirmedAppointmentPage',
    late: 'ConfirmedAppointmentPage',
    in_progress: 'ConfirmedAppointmentPage',
    person_left: 'ConfirmedAppointmentPage',
    waiting: 'ConfirmedAppointmentPage'
  }

  useEffect(() => {
    setSiderDisabled(true)
    setSiderTitle(t(`Public.${titles[appointmentStatus]}.title`))
  }, [appointmentStatus])

  const appointmentPage = {
    Mobile: MobileAppointmentPage,
    Computer: ComputerAppointmentPage,
    Tablet: TabletAppointmentPage
  }

  const ResponsivePage = appointmentPage[screenSize()]

  return (
    <>
      { appointment && <ResponsivePage box={appointment.box} appointment={appointment} onCancel={onCancel} appointmentStatus={appointmentStatus} /> }
    </>
  )
}
